import GameModel from '../models/GameModel';
import ManagerResult from '../ManagerResult';
import StatModel from '../models/StatModel';
import SoundManager from '../soundManager/SoundManager';
import eSoundsType from '../preloaders/sounds/eSoundsType';
import { getJackpotName } from '../decorators/jackpot';
import { formatCurrency } from '../utils/currency';

const eScoreType = {
  EST_RARE: 'MOST_RARE',
  EST_PROFIT: 'MAX_PROFIT',
  EST_RISKY: 'MOST_RISKY',
};

export default class ControllerScoreTable {
  constructor() {
    this.resolve = () => {
    };
    this.element = document.getElementById('score');
    this.tbody = this.element.getElementsByTagName('tbody')[0];
    this.title = this.element.getElementsByClassName('title')[0];

    this.playersText = this.element.getElementsByClassName('players')[0];
    this.betText= this.element.getElementsByClassName('bet_column')[0];
    this.winText = this.element.getElementsByClassName('win_amount')[0];

    this.title.innerText = this._getLocalization('score_title');
    this.playersText.innerText = this._getLocalization('players');
    this.betText.innerText = this._getLocalization('bet_column');
    this.winText.innerText = this._getLocalization('win_amount');

    this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));

    this.rows = {};
    const values = Object.values(eScoreType);
    for (let i = 0; i < values.length; i++) {
      const item = values[i];
      this.rows[item] = this.tbody.rows[i];
    }
    this.tbody.innerHTML = '';
    ManagerResult.conotrollerScore = this;
  }

  show(data) {
    this.data = data.params;
    this.element.classList.remove('hide');
    return new Promise(resolve => this.resolve = resolve);
  }

  hide() {
    this.tbody.innerHTML = '';
    this.element.classList.add('hide');
  }

  _animateScore() {
    if (!this.data) return;
    const isJackpot = this.data.reason === 'jackpot';
    this.title.innerText = isJackpot ? getJackpotName() : this._getLocalization('score_title');
    this.title.classList[isJackpot ? 'add' : 'remove']('current');
    const awards = this.data.awards.reverse();
    awards.sort((a, b) => {
      if (a.type === eScoreType.EST_RARE) return -1;
      if (a.type === eScoreType.EST_RISKY) return 1;
      if (a.type === eScoreType.EST_PROFIT && b.type === eScoreType.EST_RISKY) return -1;
      if (a.type === eScoreType.EST_PROFIT && b.type === eScoreType.EST_RARE) return 1;
    });
    let delay = 0;
    for (let i = 0; i < awards.length; i++) {
      const info = awards[i];
      const row = this.rows[info.type].cloneNode(true);
      if (StatModel.myBetsInfo.find((item) => item.betId === info.betId)) {
        row.classList.add('current');
      } else {
        row.classList.remove('current');
      }
      row.cells[1].innerText = `${info.clientId}`;
      row.cells[2].innerText = `${formatCurrency(info.betAmount, info.decimals, false)} ${info.currency}`;
      row.cells[3].innerText = isJackpot ? getJackpotName() : `${formatCurrency(info.winAmount, info.decimals, false)} ${info.currency}`;
      setTimeout(() => {
        SoundManager.play(eSoundsType.EST_CLICK, 1);
        this.tbody.appendChild(row);
      }, delay);
      delay += 250;
    }
  }

  _getLocalization(key, params) {
    return window.OPWrapperService.localizations.getLocalizedText(key, params);
  }

  _onTransitionEnd() {
    if (this.element.classList.contains('hide')) {
      this.resolve();
    } else {
      this._animateScore();
      setTimeout(() => this.hide(), 5000);
    }
  }
}
